import {
  GetDevicesDto,
  GetAppSettings,
  UpdateAppSettings,
} from "./settings.types";
import settingsService from "./settings.service";
import { createThunkWithError } from "../featureHelpers/errorParser";

export const getMySettings = createThunkWithError<GetAppSettings, void>(
  "settings/getMySettings",
  async () => {
    return await settingsService.getMySettings();
  }
);

export const getDevices = createThunkWithError<GetDevicesDto[], void>(
  "settings/getDevices",
  async () => {
    return await settingsService.getDevices();
  }
);

export const updateMySettings = createThunkWithError<
  GetAppSettings,
  UpdateAppSettings
>("settings/updateMySettings", async (data) => {
  return await settingsService.updateMySettings(data);
});
